import gsap from 'gsap';
import { Basics, isMobile } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';
import _Sidemenu from '../_app/cuchillo/layout/Sidemenu';
import Header from './Header';

export default class Sidemenu extends _Sidemenu {
  static _closeTimer = null;
  static links = [];
  static nav = GetBy.selector('nav', this.container)[0];
  static sizes = { x: 0, y: 0 };
  static timeout = 3500;

  static _startCloseTimer() {
    this._clearCloseTimer();

    this._closeTimer = setTimeout(() => {
      this.hide();
    }, this.timeout);
  }

  static _clearCloseTimer() {
    if (this._closeTimer) {
      clearTimeout(this._closeTimer);
      this._closeTimer = null;
    }
  }

  static init() {
    super.init();

    this.links = GetBy.selector('a', this.container);
    gsap.set(this.links, { y: '-20%', opacity: 0 });

    if (isMobile) return;

    this.nav.addEventListener(Basics.mouseOver, () => {
      this._clearCloseTimer();
    });

    this.nav.addEventListener(Basics.mouseOut, () => {
      this._startCloseTimer();
    });
  }

  static show() {
    super.show();

    Header.showNav();

    this._startCloseTimer();

    gsap.killTweensOf(this.links);
    for (let i = 0; i < this.links.length; i++) {
      gsap.set(this.links[i], {
        opacity: 1, delay: .15 + i * .08
      });
      gsap.set(this.links[i], {
        y: 0, delay: .2 + i * .08
      });
    }
  }

  static hide() {
    super.hide();
    Header.hideNav(.1);

    this._clearCloseTimer();

    gsap.killTweensOf(this.links);
    for (let i = this.links.length - 1; i >= 0; i--) {
      gsap.set(this.links[i], {
        y: '-20%', delay: (this.links.length - i) * .04
      });
      gsap.set(this.links[i], {
        opacity: 0, delay: (this.links.length - i) * .04 + .04
      });
    }
  }

  static resize() {
    super.resize();

    this.timeout = isMobile ? 5000 : 3500;

    const nav = GetBy.selector('nav', this.container)[0];
    this.container.style.visibility = 'visible';
    this.container.setAttribute('aria-expanded', 'true');

    this.sizes = {
      x: nav.offsetWidth,
      y: nav.offsetHeight
    }

    this.container.style.visibility = 'hidden';
    this.container.setAttribute('aria-expanded', 'false');
  }
}
